<div style="max-height: 90vh; overflow: auto" class="custom-scrollbar">
    <mat-card class="cs-container block-info">
        <h2 mat-card-title>{{ centralStation?.id ? "Edit" : "Add" }} Central Station</h2>
        <mat-card-content>
            <div *ngIf="!submitAttempted; else submittingForm">
                <form [formGroup]="receiverGroupForm" (ngSubmit)="saveCentralStation()">
                    <!-- ----------------CS Naming Area------------------------------- -->
                    <section>
                        <mat-form-field
                            style="margin: 0.5rem 0; width: 100%"
                            appearance="outline"
                            *letVar="receiverGroupFields.name as field"
                        >
                            <mat-label>Name</mat-label>
                            <input matInput id="name" type="text" placeholder="Name" formControlName="name" required />
                            <mat-error>
                                <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                            </mat-error>
                        </mat-form-field>
                    </section>

                    <section>
                        <div *ngIf="!validObj.hasValidReceivers && validObj.hasInvalidReceivers; else warning">
                            <app-clare-alert
                                messageType="error"
                                message="The device's central station does not have any valid communication paths"
                            ></app-clare-alert>
                        </div>
                        <ng-template #warning>
                            <app-clare-alert
                                *ngIf="validObj.hasValidReceivers && validObj.hasInvalidReceivers"
                                messageType="warning"
                                message="The device's central station has one or more invalid communication paths"
                            ></app-clare-alert>
                        </ng-template>
                        <header class="section-header-wrapper">
                            <h3>Communication Paths</h3>
                            <mat-hint><i>At least one is required</i></mat-hint>
                        </header>
                        <!-- -------------------Receiver Add / Edit Area---------------------------- -->
                        <ng-container *letVar="0 as commIndex">
                            <ng-container
                                *letVar="centralStation?.receivers && centralStation.receivers[0] && !pendingRemoval[0] as hasCommPath1"
                            >
                                <div class="divided-row" *ngIf="editingCommIndex !== commIndex; else commPathTmpl">
                                    <span *ngIf="hasCommPath1" class="comm-path-desc">Communication Path {{ commIndex + 1 }}</span>
                                    <div fxLayoutAlign="start center">
                                        <span class="comm-path" *ngIf="centralStation?.receivers" fxFlex="0 1 100%"
                                            ><span *ngIf="!pendingRemoval[0]"
                                                >{{ centralStation.receivers[0]?.path }}
                                                <span *ngIf="centralStation.receivers[0]"
                                                    ><br />(<clare-status-indicator
                                                        [status]="getReceiverStatus(centralStation.receivers[0])"
                                                    ></clare-status-indicator
                                                    >)</span
                                                ></span
                                            ></span
                                        >
                                        <button
                                            type="button"
                                            fxFlex="0 0 auto"
                                            mat-stroked-button
                                            color="primary"
                                            (click)="openEditReceiverDialog(commIndex)"
                                            [disabled]="isCommPathSecureXML('path1Protocol')"
                                            [style.width]="hasCommPath1 ? 'auto' : '100%'"
                                        >
                                            {{ hasCommPath1 ? "Edit" : "Add Communication Path 1" }}
                                        </button>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                        <mat-divider [vertical]="true"></mat-divider>
                        <ng-container *letVar="1 as commIndex">
                            <ng-container
                                *letVar="centralStation?.receivers && centralStation.receivers[1] && !pendingRemoval[1] as hasCommPath2"
                            >
                                <div class="divided-row" *ngIf="editingCommIndex !== commIndex; else commPathTmpl">
                                    <span *ngIf="hasCommPath2" class="comm-path-desc">Communication Path {{ commIndex + 1 }}</span>
                                    <div fxLayoutAlign="start center">
                                        <span class="comm-path" *ngIf="centralStation?.receivers" fxFlex="0 1 100%"
                                            ><span *ngIf="!pendingRemoval[1]"
                                                >{{ centralStation.receivers[1]?.path }}
                                                <span *ngIf="centralStation.receivers[1]"
                                                    ><br />(<clare-status-indicator
                                                        [status]="getReceiverStatus(centralStation.receivers[1])"
                                                    ></clare-status-indicator
                                                    >)</span
                                                ></span
                                            ></span
                                        >
                                        <button
                                            type="button"
                                            fxFlex="0 0 auto"
                                            mat-stroked-button
                                            color="primary"
                                            (click)="openEditReceiverDialog(commIndex)"
                                            [disabled]="isCommPathSecureXML('path2Protocol')"
                                            [style.width]="hasCommPath2 ? 'auto' : '100%'"
                                        >
                                            {{ hasCommPath2 ? "Edit" : "Add Communication Path 2" }}
                                        </button>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                        <!-- -------------------Standard Phone Line Area---------------------------- -->
                        <div class="divided-row" fxLayoutAlign="start center">
                            <form
                                class="phoneLine"
                                fxFlex="0 1 100%"
                                [formGroup]="phoneReceiverForm"
                                *letVar="phoneReceiverFields.path as field"
                            >
                                <mat-form-field appearance="outline">
                                    <mat-label>Standard Phone Line</mat-label>
                                    <input
                                        matInput
                                        id="path"
                                        type="text"
                                        placeholder="Enter Phone Number"
                                        formControlName="path"
                                        [errorStateMatcher]="errorMatcher"
                                        [value]="phoneReceiverChanges() | async"
                                        (blur)="blurHandler()"
                                    />
                                    <mat-error>
                                        <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                                    </mat-error>
                                </mat-form-field>
                            </form>
                            <button
                                *ngIf="phoneReceiverFields.id.value && !pendingRemoval[2]"
                                type="button"
                                fxFlex="0 0 85px"
                                mat-raised-button
                                color="warn"
                                (click)="removeStandardPhoneLine()"
                            >
                                Remove
                            </button>
                        </div>
                    </section>

                    <section *ngIf="centralStation?.id">
                        <header class="section-header-wrapper" fxLayoutGap="0.5rem" fxLayoutAlign="start center">
                            <h3 fxFlex="0 1 100%">Linked Devices</h3>
                            <button
                                type="button"
                                fxFlex="0 0 65px"
                                mat-stroked-button
                                color="primary"
                                (click)="viewDeviceList()"
                                [disabled]="!centralStation"
                            >
                                View
                            </button>
                        </header>
                    </section>

                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <button
                            fxFlex="0 0 110px"
                            id="cancel"
                            mat-stroked-button
                            [disabled]="submitAttempted"
                            type="button"
                            (click)="cancel()"
                        >
                            Cancel
                        </button>
                        <button fxFlex="0 0 110px" mat-raised-button color="primary" [disabled]="submitAttempted" type="submit">
                            Save
                        </button>
                    </div>
                </form>
            </div>
            <ng-template #submittingForm>
                <clare-spinner [text]="centralStation?.id ? 'Updating Central Station' : 'Creating Central Station'"></clare-spinner>
            </ng-template>
        </mat-card-content>
    </mat-card>
</div>
<ng-template #commPathTmpl>
    <div class="divided-row" fxLayout="column" fxLayoutAlign="center center">
        <div class="comm-path-container">
            <app-alula-receivers-group-input
                [dealerId]="dealerId"
                [description]="'Communication Path ' + (editingCommIndex + 1)"
                [receiver]="editingReceiver"
                (emitter)="setReceiver($event, editingCommIndex)"
            >
            </app-alula-receivers-group-input>
        </div>
    </div>
</ng-template>
